export enum Severity {
    Success = "success",
    Error = "error",
    Info = "info"
}
